(function() {
  const className = {
    toggle: 'js-toggle',
    target: 'js--active',
  };
  const toggles = document.querySelectorAll(`.${className.toggle}`);

  toggles.forEach((toggle) => {
    const targetSelector = toggle.dataset.target;
    const targetClassName = toggle.dataset.classname || className.target;

    if (!targetSelector) {
      return;
    }

    const targets = document.querySelectorAll(targetSelector) || [];

    toggle.addEventListener('click', () => {
      targets.forEach((target) => {
        if (toggle.dataset.targetList) {
          const list = document.querySelectorAll(toggle.dataset.targetList);

          list.forEach((item) => {
            item.hidden = true;
          });

          target.hidden = false;
        } else if (toggle.dataset.mode === 'visibility') {
          target.hidden = !target.hidden;
        } else {
          target.classList.toggle(targetClassName);
        }

        if (toggle.dataset.self) {
          toggle.classList.toggle(toggle.dataset.self);
        }

        if (toggle.classList.contains('menu-button')) {
          document.querySelector('body').classList.toggle('page');
        }
      });
    });
  });
})();

export default {};
